import Link from 'next/link';

import { ROUTES } from '@/config/routes';
import { cn } from '@/lib/cn';

export function Logo({ className }: { className?: string }) {
  return (
    <Link href={ROUTES.home} className={cn('group inline-flex items-baseline gap-2', className)}>
      <span className="font-display text-2xl leading-none font-extrabold tracking-tight text-white sm:text-3xl">
        NEMO
      </span>
      <span className="font-display text-brand-bright text-2xl leading-none font-extrabold tracking-tight sm:text-3xl">
        LAUNCHPAD
      </span>
    </Link>
  );
}
